<template>

  <div class="w-full">
    <jet-validation-errors class="mb-4"/>
    <!--          <div class="px-5 pb-2">-->
    <!--            <sign-in-with-slack-button></sign-in-with-slack-button>-->
    <!--          </div>-->

    <!--          <div class="px-5">-->
    <!--            <sign-in-with-google-button></sign-in-with-google-button>-->
    <!--          </div>-->

    <div class="px-5 pt-7 pb-2">

      <form @submit.prevent="submit">
        <div>
          <jet-label for="name" value="Name"/>
          <jet-input placeholder="Enter your username." id="name" type="text" class="mt-1 block w-full"
                     v-model="form.name" required autofocus
                     autocomplete="name"/>
        </div>

        <div class="mt-4">
          <jet-label for="email" value="Email"/>
          <jet-input placeholder="Email will be verified later." id="email" type="email" class="mt-1 block w-full"
                     v-model="form.email" required/>
        </div>

        <div class="mt-4">
          <jet-label for="password" value="Password"/>
          <jet-input placeholder="Password must be at least 8 length." id="password" type="password"
                     class="mt-1 block w-full" v-model="form.password" required
                     autocomplete="new-password"/>
        </div>

        <input type="text" hidden v-model="form.is_temp_user"/>

        <div class="mt-4">
          <jet-label for="password_confirmation" value="Confirm Password"/>
          <jet-input id="password_confirmation" type="password" class="mt-1 block w-full" placeholder="Password must be at least 8 length."
                     v-model="form.password_confirmation" required autocomplete="new-password"/>
        </div>

        <div class="mt-4" v-if="$page.props.jetstream.hasTermsAndPrivacyPolicyFeature">
          <jet-label for="terms">
            <div class="flex items-center">
              <jet-checkbox name="terms" id="terms" v-model:checked="form.terms"/>

              <div class="ml-2">
                I agree to the <a target="_blank" :href="route('terms.show')"
                                  class="underline text-sm text-gray-600 hover:text-gray-900">Terms of Service</a> and
                <a target="_blank" :href="route('policy.show')"
                   class="underline text-sm text-gray-600 hover:text-gray-900">Privacy Policy</a>
              </div>
            </div>
          </jet-label>
        </div>

        <button
            type="submit"
            class="
                mt-2
                rounded-full
                bg-blue-500
                hover:bg-blue-300
                focus:border-blue-100
                text-white
                w-full
                py-2.5
                rounded-lg
                text-lg
                font-semibold
                text-center
                inline-block
              "
            :class="{ 'opacity-25': form.processing }" :disabled="form.processing"
        >
          <span class="inline-block mr-2">Sign Up</span>
        </button>

      </form>
    </div>

    <div class="px-5 pb-2">
      <sign-in-with-slack-button></sign-in-with-slack-button>
    </div>
    <div class="px-5 pb-2">
      <sign-in-with-google-button></sign-in-with-google-button>
    </div>
    <div class="py-5">
      <div class="grid grid-cols-2 gap-1">
        <div class="text-center sm:text-left whitespace-nowrap">
          <button
              @click=" this.$inertia.visit(route('password.request'))"
              class="
                    transition
                    duration-200
                    mx-5
                    px-5
                    py-4
                    cursor-pointer
                    font-normal
                    text-lg
                    rounded-lg
                    text-blue-500
                    focus:outline-none
                    ring-inset
                  "
          >
                  <span
                      class="
                      text-blue-500
                      font-bold
                      inline-block
                      ml-1
                      hover:text-blue-300
                    "
                  >Forgot Password?</span
                  >
          </button>
        </div>
        <div class="text-center sm:text-right whitespace-nowrap">
          <button
              class="
                    transition
                    duration-200
                    mx-5
                    px-5
                    py-4
                    cursor-pointer
                    font-normal
                    text-lg
                    rounded-lg
                    text-blue-500
                    focus:outline-none
                    ring-inset
                  "
          >
                  <span
                      class="
                      text-blue-500
                      font-bold
                      inline-block
                      ml-1
                      hover:text-blue-300
                    "
                  >Contact us</span
                  >
          </button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import JetAuthenticationCard from '@/Jetstream/AuthenticationCard'
import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo'
import JetButton from '@/Jetstream/Button'
import JetInput from '@/Jetstream/Input'
import JetCheckbox from "@/Jetstream/Checkbox";
import JetLabel from '@/Jetstream/Label'
import JetValidationErrors from '@/Jetstream/ValidationErrors'
import {message} from "ant-design-vue";
import SignInWithSlackButton from "@/Components/SocialButton/SignInWithSlackButton";
import SignInWithGoogleButton from "@/Components/SocialButton/SignInWithGoogleButton";

export default {
  components: {
    SignInWithGoogleButton,
    SignInWithSlackButton,
    JetAuthenticationCard,
    JetAuthenticationCardLogo,
    JetButton,
    JetInput,
    JetCheckbox,
    JetLabel,
    JetValidationErrors
  },

  props: ['reload'],
  data() {
    return {
      form: this.$inertia.form({
        name: this.$page.props.user ? this.$page.props.user.name : '',
        email: '',
        password: '',
        password_confirmation: '',
        terms: false,
        is_temp_user: '',
      })
    }
  },

  methods: {
    submit() {

      let app = this;
      this.form.is_temp_user = this.$page.props.user ? this.$page.props.user.is_temp_user : ''

      if (this.form.is_temp_user) {

        this.form.processing = true;
        axios.post(this.route('custom.auth.convert'), this.form).then(
            response => {
              if (response.data.success) {
                window.location.reload();
              } else {
                message.error(response.data.message, 5);
                app.form.processing = false;
              }
            });
      } else {
        this.form.post(this.route('register'), {
          onFinish: () => this.form.reset('password', 'password_confirmation'),
          onSuccess: () => {
            message.success("Welcome to AgileSuite, we wish you have a great journey.", 3);
            if (app.reload === false) {
            } else {
              window.location.reload();
            }
          },
        })
      }
    }
  }
}
</script>
